module.exports = __webpack_public_path__ + "static/reports_icon-9f599bd9c441f4249bdac9e0e975f857.png";